import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVegaSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		filter: "url(#filter0_d_1914_226281)",
		children: [/* @__PURE__ */ _jsx("rect", {
			x: 4,
			y: 2,
			width: 42,
			height: 42,
			rx: 5.25,
			fill: "url(#paint0_linear_1914_226281)"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M25.8105 32.9784H25.9265L25.9731 32.8722L34.2795 13.9544L34.3888 13.7055H34.117H32.2112H32.0952L32.0486 13.8117L25 29.8652L17.9514 13.8117L17.9048 13.7055H17.7888H15.8831H15.6112L15.7205 13.9544C16.8697 16.5717 18.0188 19.1891 19.168 21.8065C20.7874 25.4951 22.4069 29.1837 24.0267 32.8722L24.0733 32.9784H24.1892H25.8105Z",
			fill: "white",
			stroke: "white",
			strokeWidth: .355115
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("filter", {
		id: "filter0_d_1914_226281",
		x: 0,
		y: 0,
		width: 50,
		height: 50,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 2 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_1914_226281"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_1914_226281",
				result: "shape"
			})
		]
	}), /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_1914_226281",
		x1: 4,
		y1: 44,
		x2: 43.7623,
		y2: -.0212282,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { offset: .0459 }), /* @__PURE__ */ _jsx("stop", {
			offset: .9452,
			stopColor: "#272D3B"
		})]
	})] })]
});
export default SvgVegaSm;
